import React from "react";
import { Grid, Card } from "@mui/material";
import colors from "../../../colors";
import MyContractsTest from "./myContracts/myContractsNew/MyContractsTest";
import { useSelector, useDispatch } from "react-redux";
import {
  selectUtilityState,
  displayInvoiceList,
  displaySingleInvoice,
  displayMainUtilityView,
  clearUtilitySliceState,
} from "../../../../features/utilities/utilitySlice";
import {
  selectGlobalDataState,
  setGeneralMessage,
  setTransactionHasBeenMade,
} from "../../../../features/global/globalDataSlice";
import { selectUserInfo } from "../../../../features/userInfo/userInfoSlice";
import {
  selectMyContractsState,
  resetSelectedContractInfo,
} from "../../../../features/myContracts/myContractsSlice";
import smallLoadingAnimation from "../../../../icons/lottieAnimations/smallLoading.json";
import InvoiceList from "./InvoiceList";
import SingleExpandedInvoice from "./SingleExpandedInvoice";
import Lottie from "lottie-react";
import { useLocation } from "react-router-dom";
import { texts } from "../../../general/texts";
import TaksatVendoreSingleExpandedIncoice from "./taksatVendore/TaksatVendoreSingleExpandedIncoice";
import SiguracioneSingleExpandedInvoice from "./siguracionet/SiguracioneSingleExpandedInvoice";

const selectedButtonStyle = {
  backgroundColor: colors.lightOrange,
  color: colors.orange,
  width: "150px",
  height: "40px",
  fontFamily: "GerberaBold",
  textTransform: "none",
  fontSize: "1rem",
  border: "2px solid" + colors.orange,
  borderRadius: "10px",
  "&:hover": {
    backgroundColor: colors.lightOrange,
  },
  "@media (max-width: 899px)": { width: "130px", height: "40px" },
};

const defaultButtonStyle = {
  backgroundColor: colors.lightBlue,
  width: "150px",
  height: "40px",
  borderRadius: "10px",
  textTransform: "none",
  fontFamily: "GerberaLight",
  fontSize: "1rem",
  color: colors.darkBlue,
  "&:hover": {
    backgroundColor: colors.lightOrange,
  },
  "@media (max-width: 899px)": { width: "130px", height: "40px" },
};

const Utility = (props) => {
  const utilitySliceState = useSelector(selectUtilityState);
  const globalDataSliceState = useSelector(selectGlobalDataState);
  const myContractsSliceState = useSelector(selectMyContractsState);
  const dispatch = useDispatch();
  const location = useLocation();
  const userInfo = useSelector(selectUserInfo);
  const utilityName = location.pathname.slice(
    location.pathname.lastIndexOf("/") + 1,
    location.pathname.length
  );
  const userInfoSliceState = useSelector(selectUserInfo);

  React.useEffect(() => {
    utilitySliceState.shouldDisplaySingleInvoice &&
      dispatch(displaySingleInvoice());
    utilitySliceState.shouldDisplayInvoiceList &&
      dispatch(displayInvoiceList());
    utilitySliceState.shouldDisplayMainUtilityView &&
      dispatch(displayMainUtilityView());
    if (utilitySliceState.isTransactionSuccessfullyCompleted) {
      dispatch(
        setGeneralMessage({
          type: "success",
          message: texts["message-success-trx"],
        })
      );
      dispatch(setTransactionHasBeenMade(true));
      dispatch(clearUtilitySliceState());
    }
    return () => {
      dispatch(resetSelectedContractInfo());
    };
  }, [
    utilitySliceState.isTransactionSuccessfullyCompleted,
    utilitySliceState.shouldDisplaySingleInvoice,
    utilitySliceState.shouldDisplayInvoiceList,
    utilitySliceState.shouldDisplayMainUtilityView,
  ]);

  return (
    <Grid container spacing={"2%"} pt={"3%"}>
      <Grid
        container
        item
        md={6.5}
        justifyContent={"right"}
        sx={{ "@media (max-width: 899px)": { justifyContent: "center" } }}
      >
        <Card
          sx={{
            borderRadius: "20px",
            boxShadow: "0 0 15px 5px #E5E7EA",
            width: "60%",
            "@media (max-width: 1440px )": { width: "70%" },
            "@media (max-width: 1320px )": { width: "90%" },
          }}
        >
          {utilitySliceState.shouldDisplayInvoiceList === false &&
            utilitySliceState.shouldDisplaySingleInvoice === false && (
              <props.utility
                selectedContractInfo={
                  myContractsSliceState.selectedContractInfo
                }
                userInfoSliceState={userInfoSliceState}
                utilityName={utilityName}
                defaultButtonStyle={defaultButtonStyle}
                selectedButtonStyle={selectedButtonStyle}
                utilitySliceState={utilitySliceState}
                globalDataSliceState={globalDataSliceState}
                utilityInfo={props.utilityInfo}
              />
            )}
          {utilitySliceState.shouldDisplayInvoiceList === true && (
            <InvoiceList
              utilityInfo={props.utilityInfo}
              utilityName={
                utilityName === "UJESJELLES"
                  ? utilitySliceState.utilityName
                  : utilityName
              }
              invoices={utilitySliceState.invoiceList}
            />
          )}
          {utilitySliceState.shouldDisplaySingleInvoice === true &&
            (utilityName === "TAKSAT_DURRES" ||
              utilityName === "TAKSAT_SHKODER" ? (
              <TaksatVendoreSingleExpandedIncoice
                utilityName={utilityName}
                invoice={utilitySliceState.singleInvoice}
              />
            ) : utilityName === "Siguracione" ? (
              <SiguracioneSingleExpandedInvoice
                utilityName={utilityName}
                invoice={utilitySliceState.singleInvoice}
              />
            ) : (
              <SingleExpandedInvoice
                utilityName={
                  utilityName === "UJESJELLES"
                    ? utilitySliceState.utilityName
                    : utilityName
                }
                invoice={utilitySliceState.singleInvoice}
              />
            ))}
          <Grid container justifyContent={"center"}>
            <Grid item md={3} xs={3}>
              {utilitySliceState.isLoading && (
                <Lottie
                  animationData={smallLoadingAnimation}
                  loop={true}
                  autoplay={true}
                />
              )}
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid
        container
        item
        md={4.5}
        justifyContent={"left"}
        sx={{ "@media (max-width: 899px)": { justifyContent: "center" } }}
      >
        <MyContractsTest utilityName={utilityName} currentLocation="utility" />
      </Grid>
    </Grid>
  );
};

export default Utility;
